import { render } from "./ModoApresentacaoGestaoEntregas.vue?vue&type=template&id=e8995594&scoped=true"
import script from "./ModoApresentacaoGestaoEntregas.vue?vue&type=script&lang=js"
export * from "./ModoApresentacaoGestaoEntregas.vue?vue&type=script&lang=js"

import "./ModoApresentacaoGestaoEntregas.vue?vue&type=style&index=0&id=e8995594&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8995594"]])

export default __exports__